export const PROCESSFLOW_LIST_PATH = "/processflows";
export const OBJECTIVE_LIST_PATH = "/objectives";

export const processflowDetailPath = (uuid: string, routeBase = PROCESSFLOW_LIST_PATH): string =>
    `${routeBase}/${uuid}`;

export const PROCESSFLOW_TYPE_READINESS = "readiness" as const;
export const PROCESSFLOW_TYPE_OBJECTIVE = "objective" as const;

export type ProcessflowRouteType = typeof PROCESSFLOW_TYPE_READINESS | typeof PROCESSFLOW_TYPE_OBJECTIVE;

export const PROCESSFLOW_STATUS_OPTION = "PROCESSFLOW_STATUS_OPTION";
export const PROCESSFLOW_SEVERITY_OPTION = "PROCESSFLOW_SEVERITY_OPTION";
export const PROCESSFLOW_TYPE_OPTION = "PROCESSFLOW_TYPE_OPTION";
export const PROCESSFLOW_SCOPE_OBJECT_OPTION = "PROCESSFLOW_SCOPE_OBJECT_OPTION";
export const PROCESSFLOW_REFERENCE_EVENT_OPTION = "PROCESSFLOW_REFERENCE_EVENT_OPTION";
export const PROCESSFLOW_OWNER_OPTION = "PROCESSFLOW_OWNER_OPTION";
export const PROCESSFLOW_COMPLETION_RULE_OPTION = "PROCESSFLOW_COMPLETION_RULE_OPTION";
export const PROCESSFLOW_TIMING_UNIT_OPTION = "PROCESSFLOW_TIMING_UNIT_OPTION";
export const PROCESSFLOW_TIMING_DIRECTION_OPTION = "PROCESSFLOW_TIMING_DIRECTION_OPTION";
export const PROCESSFLOW_SCOPE_DIMENSION_OPTION = "PROCESSFLOW_SCOPE_DIMENSION_OPTION";
export const PROCESSFLOW_SCOPE_DISPLAY_MODE_OPTION = "PROCESSFLOW_SCOPE_DISPLAY_MODE_OPTION";
export const PROCESSFLOW_STEP_STATUS_OPTION = "PROCESSFLOW_STEP_STATUS_OPTION";
export const PROCESSFLOW_TASK_STATUS_OPTION = "PROCESSFLOW_TASK_STATUS_OPTION";
export const PROCESSFLOW_TASK_PRIORITY_OPTION = "PROCESSFLOW_TASK_PRIORITY_OPTION";

export const PROCESSFLOW_STATUS_ACTIVE = "active";

/** Processflow scope rows always use equality when filtering criteria queries. */
export const PROCESSFLOW_SCOPE_OPERATOR_EQUALS = "=";
